import React from 'react';

function Dashboard() {
  return <div className="container max-w-4xl mx-auto px-6 py-4" />;
}

export default Dashboard;
